import { useLocation } from 'react-router-dom';

interface Step {
  key: string;
  label: string;
  path: string;
}

const steps: Step[] = [
  { key: 'step-1', label: 'Treatment Type', path: '/bookonline/step-1' },
  { key: 'step-2', label: 'Patient Type', path: '/bookonline/step-2' },
  { key: 'step-3', label: 'Time Slots', path: '/bookonline/step-3' },
  { key: 'step-4', label: 'Patient Details', path: '/bookonline/step-4' },
  { key: 'confirmation', label: 'Confirmation', path: '/bookonline/confirmation' },
];

export const Stepper = () => {
  const { pathname } = useLocation();
  const activeIndex = steps.findIndex(s => pathname.startsWith(s.path));

  return (
    <div className="pt-8">
      <ol className="relative space-y-14">
        <span aria-hidden className="absolute left-[16px] top-0 bottom-0 w-1 bg-gray-200" />
        {steps.map((s, idx) => {
          const isActive = idx === activeIndex;
          const isCompleted = idx < activeIndex;
          return (
            <li key={s.key} className={'relative flex items-center gap-3'}>
              <span aria-hidden className={`absolute left-[18px] -z-10 top-0 bottom-0 w-0.5 ${isCompleted || isActive ? 'bg-teamcare-yellow' : 'bg-transparent'}`} />
              <span className={`inline-flex items-center justify-center w-9 h-9 rounded-full text-xs font-semibold border relative z-10 ${isCompleted ? 'bg-teamcare-yellow shadow-[2px_2px_0_0_rgba(0,0,0,100)] text-white border-white' : isActive ? 'border-teamcare-yellow text-teamcare-yellow bg-white' : 'border-gray-300 text-gray-500 bg-white'}`}>
                {isCompleted ? (
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-5 h-5">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-7.25 7.25a1 1 0 01-1.414 0l-3-3a1 1 0 111.414-1.414L8.5 11.586l6.543-6.543a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                ) : (
                  idx + 1
                )}
              </span>
              <div className="flex flex-col">
                <span className={`text-xs uppercase tracking-wide font-bold ${isActive ? 'text-teamcare-yellow' : 'text-gray-400'}`}>Step {idx + 1}</span>
                <span className={`text-sm font-semibold ${isActive ? 'text-gray-900' : isCompleted ? 'text-gray-700' : 'text-gray-500'}`}>{s.label}</span>
              </div>
            </li>
          );
        })}
      </ol>
    </div>
  );
};


